module.exports = __webpack_public_path__ + "media/images/house_icon@3x-ac6ebf8e.png";